<template>
  <b-modal id="choose_banks" size="lg" centered hide-header hide-footer>
    <div id="payment-choose-bank" class="fee-method">
      <ul class="list-unstyled row mx-n1 mx-md-n3 mb-0 transaction-select" v-if="banksStatus === 'loaded'" v-match-heights="{el: ['a.equal-height']}">
        <li class="col-12 col-xl-6 px-1 px-md-3 mb-3" v-for="(record, $index) in banks" :key="$index">
          <a href="#" class="equal-height">
            <img :src="require('@/assets/images/' + record.icon)" class="img-fluid d-block m-auto" />
            <p class="mt-1 mb-2"><strong>{{ record.name }}</strong></p>
            <span v-if="record.account">
              Account Number<br />
              <strong>{{ record.account }}</strong><br />
            </span>
            <span v-if="record.iban">
              IBAN<br />
              <strong>{{ record.iban }}</strong><br />
            </span>
            <span v-if="record.branch">
              Branch Code<br />
              <strong>{{ record.branch }}</strong><br />
            </span>
            <span v-if="record.sort_code">
              Sort Code<br />
              <strong>{{ record.sort_code }}</strong><br />
            </span>
            <span v-if="record.bic_code">
              BIC<br />
              <strong>{{ record.bic_code }}</strong><br />
            </span>
            <span v-if="record.intermediary_bic">
              Intermediary BIC<br />
              <strong>{{ record.intermediary_bic }}</strong><br />
            </span>
            <span v-if="record.swift">
              Swift Code<br />
              <strong>{{ record.swift }}</strong>
            </span>
          </a>
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  props: {
    currency: String
  },
  computed: {
    ...mapState({
      record: state => state.banks,
      banks: state => state.banks.banks
    }),
    banksStatus () {
      return this.record.status
    }
  },
  mounted () {
    this.get(this.currency)
  },
  methods: {
    ...mapActions('banks', ['get'])
  }
}
</script>
